"use client";

import { c as _c } from "react/compiler-runtime";
import { BehovViewControlProvider } from "@/app/(behov)/[behovId]/state/contextState";
import type { LederInfo } from "@/server/fetchData/fetchLederInfo";
import { EditView } from "./EditView";
import { SubmitView } from "./SubmitView";
type ViewControlProps = {
  lederInfo: LederInfo;
  behovId: string;
};
export function ViewControl(t0) {
  const $ = _c(3);
  const {
    lederInfo,
    behovId
  } = t0;
  let t1;
  if ($[0] !== behovId || $[1] !== lederInfo) {
    t1 = <BehovViewControlProvider EditView={EditView} SubmitView={SubmitView} lederInfo={lederInfo} behovId={behovId} />;
    $[0] = behovId;
    $[1] = lederInfo;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
}